import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { CircularProgress } from '../../utils/materialUI';
import '../../assets/styles/Disclaimer.css';
import { listConstants } from '../../actions/ConstantsActions';
import { validateEmail } from '../../utils/validators';
import { sendForgotPasswordLink } from '../../actions/ForgotPasswordActions';
import { HTML_PAGE } from '../../constants/globals';
import { extractSubString } from '../../utils/utils';

class ForgotPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submitted: false,
            unfilled: false,
            email: '',
        };
    }

    componentDidMount() {
        this.props.listConstants(HTML_PAGE.DISCLAIMER);
        document.title = 'Forgot Password » Askimam';
    }

    handleChange = (event) => {
        event.preventDefault();
        const name = event.target.name;
        this.setState({ [name]: event.target.value });
    };

    emailValidation = (event, error) => {
        event.preventDefault();
        if (!(this.state.email)) {
            return;
        }
        this.setState({ email: event.target.value, emailError: !!error });
    };

    handleSubmit = () => {
        const { email } = this.state;

        if (!(email)) {
            this.setState({ unfilled: true, submitted: false });
            return;
        }

        if (this.state.emailError) {
            this.setState({ unfilled: false, submitted: false });
            return;
        }

        this.props.sendForgotPasswordLink(email);

        this.setState({
            email: '', unfilled: false, submitted: true, emailError: false,
        });
    };

    render() {
        const { error, isLoading } = this.props.forgotPassword;
        const resetLinkSuccess = this.state.submitted && !isLoading && !error;
        const resetLinkFailure = this.state.submitted && !isLoading && error;

        return (
            <div>
                <div className="row">
                    <div className="col-md-8"><h2 className="category-heading">Forgot Password</h2></div>
                    <div className="col-md-4">
                        {
                            isLoading
                            && <div className="center"><CircularProgress color="inherit" /></div>
                        }
                    </div>
                </div>
                <fieldset id="forgot-password">
                    {
                        resetLinkSuccess
                            && <div className="success-message">Kindly check your email to reset password.</div>
                    }
                    {
                        this.state.unfilled
                            && <div id="authMessage" className="auth-message">Please provide email.</div>
                    }
                    {
                        this.state.emailError
                            && <div className="error-message">Please enter a valid email address.</div>
                    }
                    {
                        resetLinkFailure
                        && <div className="error-message">Error! {extractSubString(Object.values(error || '').join(' '), 0, 300)}</div>
                    }
                    <input
                        type="text"
                        id="field-subscribe"
                        placeholder="Email"
                        name="email"
                        size="20"
                        onChange={this.handleChange}
                        onBlur={e => this.emailValidation(e, validateEmail(this.state.email))}
                        value={this.state.email}
                    />
                    <button className="submit-forgot-password" type="submit" onClick={this.handleSubmit}>
                        Submit
                    </button>
                </fieldset>
            </div>
        );
    }
}

ForgotPassword.propTypes = {
    forgotPassword: PropTypes.object.isRequired,
    listConstants: PropTypes.func.isRequired,
    sendForgotPasswordLink: PropTypes.func.isRequired,
};

const mapStateToProps = ({ listConstantsReducer, forgotPasswordReducer }) => ({
    constants: listConstantsReducer,
    forgotPassword: forgotPasswordReducer,
});

export default connect(mapStateToProps, { listConstants, sendForgotPasswordLink })(ForgotPassword);
